import React from "react";

const RowData = (props) => {
    const {item,legends,campaign} = props;
    return(<>
        <div className="row">
            <div className="group-row-left">
                <div className="row-data-1" style={{backgroundColor:legends[item.campaign]}}>{item.total_send}</div>
                <div className="row-data-2" style={{color:legends[item.campaign]}}>{item.start_time}</div>
            </div>
            <div className="group-row-right">
                <div className="row-data-3">
                    <i className='bx bx-undo'></i>
                    <span>{(item.types).length}</span>
                </div>
            </div>
            <div className="slot-tooltip">
                <ul className="tooltip">
                    <li>
                        <div className="campaign-row">
                            <span className="row-title">Campaign:</span>
                            <span className="row-value">{campaign[item.campaign]}</span>
                        </div>
                    </li>
                    {(item.types).map((row,k)=>(
                        <li key={k}>
                            <div className="campaign-row">
                                <span className="row-title">Name:</span>
                                <span className="row-value">{row.name}</span>
                            </div>
                            <div className="campaign-row">
                                <span className="row-title">Rule:</span>
                                <span className="row-value">{row.rule}</span>
                            </div>
                        </li>)
                    )}
                </ul>
            </div>
        </div>
    </>);

}

export default RowData;